import { useStoreState } from 'pullstate';
import { AppStore } from '../stores/AppStore.js';
import { api } from './apiFunctions';

export const getToken = async (response, navigate) => {
    const authResponse = await api.post(`/api/auth`, response, {
        headers: {
            'Content-Type': 'application/json',
        }
    })

    const data = authResponse.data

    AppStore.update((s) => { s.googleToken = data.token })
    AppStore.update((s) => { s.user = data.user })

    localStorage.setItem('userEmail', data.user.email)

    if (authResponse.status === 200) {
        const slackAuth = await api.get(`/slack/${data.user.id}`)
        if (slackAuth?.data?.length) {
            AppStore.update((s) => { s.slackUserData = slackAuth.data; });
        }

        if (data.token && slackAuth.data.length) {
            navigate('/employee')
        } else if (data.token && !slackAuth.data.length) {
            navigate('/slack-auth')
        } else if (!data.token) {
            navigate('/')
        }

    } else {
        navigate('/not-auth')
    }
}

export const getEmployees = async () => {
    const token = AppStore.currentState.googleToken

    try {
        const response = await api.get(`/users`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });

        const data = response.data

        if (data.length) {
            data.sort((a, b) => a.full_name.localeCompare(b.full_name));
            AppStore.update((s) => { s.employees = data });
            AppStore.update((s) => { s.user = data.find( e => e.email === localStorage.getItem('userEmail') ) });
        }
        return data
    } catch (error) {
        console.error('Error:', error);
    }
}

export const getApiEnvironment = async () => {
    const token = AppStore.currentState.googleToken

    try {
        const response = await api.get('/api/v1/env', {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        AppStore.update((s) => { s.apiEnvironment = response.data.environment })
    } catch (error) {
        AppStore.update((s) => { s.apiEnvironment = 'ENV ERROR' })
    }
}

export const getStrengths = async () => {

    try {
        const response = await api.get(`/user/strengths`)
        if (response.data.length) {
            AppStore.update((s) => { s.strengths = response.data })
        }
        return response.data
    } catch (error) {
        console.error(error)
    }
}

export const getSnackbar = async () => {

    const openAlert = (message, type) => {
        AppStore.update((s) => {
            s.snackbar.message = message
            s.snackbar.type = type;
            s.snackbar.open = true;
        });
    }

    const handleClose = () => {
        AppStore.update((s) => { s.snackbar.open = false })
    }

    AppStore.update((s) => { s.snackbar = { openAlert: openAlert, handleClose: handleClose } })

}

export const getSlackTokenFromDatabase = async () => {
    const slackUserData = useStoreState(AppStore.currentState.slackUserData);

    if (slackUserData) {
        return
    }

    try {
        const authResponse = await api.get(`/slack/${userLogged?.id}`)
        AppStore.update((s) => {
            s.slackUserTokenObject = authResponse.data;
        });

    } catch (e) {
        console.error('Error', e)
    }

}

export const getPeopleBuilders = async () => {

    try {
        const responseUserPeopleBuilder = await api.get(`/people-builders`)
        const peopleBuilderData = responseUserPeopleBuilder.data.filter(pb => !pb.player.suspended && pb.player.etro_team)

        if (peopleBuilderData.length) {
            AppStore.update((s) => { s.peopleBuilders = peopleBuilderData })
        }
        return peopleBuilderData
    } catch (error) {
        console.log(error)
    }
}

export const getGoals = async () => {
    try {
        const response = await api.get('/goals')
        AppStore.update((s) => { s.goals = response.data })
        return response.data
    } catch (error) {
        console.log('goals stored', error)
    }
}

export const getCheckIns = async () => {

    try {
        const response = await api.get('/checkins')
        AppStore.update((s) => { s.checkIns = response.data })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const getCheckInGoals = async () => {

    try {
        const response = await api.get(`/checkin-goals`)
        AppStore.update((s) => { s.checkInGoals = response.data })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const getDepartments = async () => {

    try {
        const response = await api.get(`/departments`)
        const departments = [...response.data.sort((a, b) => a.department.localeCompare(b.department))]
        AppStore.update((s) => { s.departments = departments })
        return departments
    } catch (error) {
        console.log(error)
    }
}

export const getTitles = async () => {
    const googleToken = AppStore.currentState.googleToken;

    try {
        const response = await api.get(`/titles`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${googleToken}`
            }
        })
        const titles = [...response.data.sort((a, b) => a.title.localeCompare(b.title))]
        AppStore.update((s) => { s.titles = titles })
        return titles
    } catch (e) {
        console.log(e)
        return e
    }

}

export const getWorkLocations = async () => {
    const googleToken = AppStore.currentState.googleToken;

    try {
        const response = await api.get(`/work-locations`, {
            headers: {
                Authorization: `Bearer ${googleToken}`,
                'Content-Type': 'application/json'
            }
        })
        if (response.status === 200) {
            const locations = [...response.data]
            locations.sort((a, b) => a.building_name?.localeCompare(b.building_name))
            AppStore.update((s) => { s.workLocations = locations });
            return locations
        }

    } catch (error) {
        console.error('Somenthing was wrong for bring work locations')
        console.error(error)
    }

}

export const getPbSettings = async () => {
    try {
        const response = await api.get('/people-builder-settings')
        const data = response.data
        if (data) {
            AppStore.update((s) => { s.pbSettings = data })
        }
    } catch (error) {
        console.log('error', error)
    }
}
